import s from './List.scss'
import { Checkbox } from 'components/ideal-core-ui'
import { FileIcon, defaultStyles } from 'react-file-icon'
import { getBaseUrl } from 'utils/api'

const List = ({ ids, triggerCheckbox, documents }) => {
  return (
    <div className={s.documentsWrapper}>
      {documents.map(document => {
        const extension = document.contentType.split('/')[1]
        return (
          <div className={s.document} key={document.id}>
            <Checkbox
              isChecked={ids.includes(document.id)}
              triggerCheckbox={() => triggerCheckbox(document.id)}
              className={s.label}
            />
            <label>
              <span style={{ display: 'inline-block', width: 20 }}>
                <FileIcon extension={extension} {...defaultStyles[extension]} />
              </span>
              <a
                className={s.fileName}
                href={`${getBaseUrl('/v1/test/get-s3-object')}/${document.s3Key}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {document.originalFileName}
              </a>
            </label>
          </div>
        )
      })}
    </div>
  )
}

export default List
